export const StatusType = {
  FIRE: "fire",
  BLEED: "bleed",
  POISON: "poison",
  STUN: "stun",
};

export class StatusEffect {
  constructor(effectData) {
    this.type = effectData.type;
    this.name = effectData.name;
    this.tickSpeed = effectData.tickSpeed;
    this.tickTimer = 0;
    this.stacks = effectData.stacks;
    this.chance = effectData.chance;
    this.isTurnBased = effectData.isTurnBased || false;
    
    this.stats = {
      weaponDamage: effectData.weaponDamage,
      baseMultiplier: effectData.baseMultiplier,
      rollMultiplier: effectData.rollMultiplier,
    };
    this.stackDamage = this.stats.weaponDamage * this.stats.baseMultiplier * this.stats.rollMultiplier;
  }

  tick() {
    this.tickTimer++;
    if (this.tickTimer >= this.tickSpeed) {
      this.tickTimer = 0;
      const damage = this.stackDamage;
      this.stacks--;
      return damage;
    }
    return 0;
  }

  addStacks(amount) {
    this.stacks += amount;
  }
}
